module.exports = __webpack_public_path__ + "static/media/image-card-11.b428a87a.png";